<template>
  <div
    class="rfp-rr-most-helpful-favorable-review-133-or rr-most-fav-review-left float-left"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActiveMhfr }"
  >
    <div class="rfp-rr-most-helpful-favorable-review-134-or rr-most-fav-review-left-inner">
      <h3 class="rfp-rr-most-helpful-favorable-review-135-or rr-sub-title black">
        {{ headerTitleMhfr }}
      </h3>
      <span v-if="noFavorableReviewFoundMhfr">
        <span
          class="rfp-rr-most-helpful-favorable-review-136-or review-stars"
          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActiveMhfr }"
        >
          <refapp-star-rating
            :aria-label="starRatingAccessibleLabel"
            class="vue-star-rating"
            star-classes="vue-star-rating-star"
            :increment="starRatingIncrementValueMhfr"
            :max-rating="starRatingMaxRatingValueMhfr"
            :inactive-color="starRatingInactiveColorMhfr"
            :active-color="starRatingActiveColorMhfr"
            :star-size="starRatingStarSizeMhfr"
            :rating="overallRating"
            readonly
          />
        </span>
        <p class="rfp-rr-most-helpful-favorable-review-138-or clear">
          <span
            v-if="showHideNicknameMhfr"
            class="rfp-rr-most-helpful-favorable-review-139-or black bold"
            >{{ labelDateMhfr }}</span
          ><span v-if="showCreatedAtMhfr"> - {{ reviewDateMhfr }}</span>
        </p>
        <h3
          v-if="showHideSubTitleMhfr && subTitleMhfr"
          class="rfp-rr-most-helpful-favorable-review-140-or rr-sub-title black clear"
        >
          {{ subTitleMhfr }}
        </h3>
        <p class="rfp-rr-most-helpful-favorable-review-141-or clear">
          <span class="rfp-rr-most-helpful-favorable-review-142-or rr-sub-content-restricted"
            >{{ subContentMhfr }}
          </span>
          <span
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            class="rfp-rr-most-helpful-favorable-review-143-or bold rr-show-full-review"
            @keydown.space.prevent
            @keyup.space="showFullReviewPopup"
            @keydown.enter="showFullReviewPopup"
            @click="showFullReviewPopup"
          >
            {{ showFullReviewMhfr }}
          </span>
        </p>
        <p
          v-if="isProductFreeMhfr && showFreeProductMhfr"
          class="rfp-rr-most-helpful-favorable-review-152-or"
        >
          <span>{{ isProductFreeDisplayTextMhfr }}</span>
        </p>
        <p class="rfp-rr-most-helpful-favorable-review-144-or clear">{{ labelHelpfulMhfr }}</p>
        <p
          role="button"
          tabindex="0"
          class="rfp-rr-most-helpful-favorable-review-145-or clear bold rr-see-more-reviews reviews-four-five"
          @keydown.space.prevent
          @keyup.space="filterRatingSpecific"
          @keyup.enter="filterRatingSpecific"
          @click="filterRatingSpecific"
        >
          {{ filterStarReviewsMhfr }}
        </p>
        <p
          v-if="commentAddedMhfr"
          role="button"
          :aria-expanded="String(showCommentText)"
          tabindex="0"
          class="rfp-rr-most-helpful-favorable-review-146-or clear bold rr-see-more-reviews reviews-four-five"
          @keydown.space.prevent
          @keyup.space="showComments"
          @keydown.enter="showComments"
          @click="showComments"
        >
          {{ commentAddedButtonMhfr }}
        </p>
        <p
          v-if="showCommentText"
          class="rfp-rr-most-helpful-favorable-review-147-or comment___text"
        >
          {{ commentAddedMhfr }}
        </p>
      </span>
      <span
        v-if="!noFavorableReviewFoundMhfr"
        class="rfp-rr-most-helpful-favorable-review-148-or"
        >{{ noFavorableReviewFoundTextMhfr }}</span
      >
    </div>
    <div
      v-if="activePopup"
      class="rfp-rr-most-helpful-favorable-review-149-or review-popup-overlay"
      style="display: block"
    ></div>
    <rfp-ratings-show-full-review
      v-if="activePopup"
      :header-title="headerTitlePopupMhfr"
      :label-quality-of-product="labelQualityOfProductMhfr"
      :rate-quality-of-product="rateQualityOfProductMhfr"
      :summary="summaryMhfr"
      :rrid="rridMhfr"
      :helpful-labels="helpfulLabelMhfr"
      :is-reported-by-user="isReportedByUser"
      :reported-text="reportedTextMhfr"
      :report-text="reportTextMhfr"
      :update-helpful-review-apis="updateHelpfulReviewApiMhfr"
      :update-not-helpful-review-apis="updateNotHelpfulReviewApiMhfr"
      :report-review-apis="reportReviewApiMhfr"
      :is-recommends="isRecommendMhfr"
      :helpful-icon="helpfulIconMhfr"
      :helpful-icon-alt="helpfulIconAltMhfr"
      :non-helpful-icon="nonHelpfulIconMhfr"
      :non-helpful-icon-alt="nonHelpfulIconAltMhfr"
      :recommend-list-icons="recommendListIconMhfr"
      :recommend-icon-alt-texts="recommendIconAltTextMhfr"
      :product-names="productNameMhfr"
      :review-contents="subContentMhfr"
      :review-titles="subTitleMhfr"
      :facebook-captions="facebookCaptionMhfr"
      :facebook-share-enableds="facebookShareEnabledMhfr"
      :share-display-configs="shareDisplayConfigMhfr"
      :facebook-icons="facebookIconMhfr"
      :facebook-icon-alts="facebookIconAltMhfr"
      :facebook-tool-tips="facebookToolTip"
      :show-hide-quality-of-products="showHideQualityOfProductMhfr"
      :show-hide-sub-titles="showHideSubTitleMhfr"
      :field="fields"
      :modal-close-button-accessible-label="modalCloseButtonAccessibleLabel"
      :is-voted-by-user="localIsVotedByUser"
    >
    </rfp-ratings-show-full-review>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpRatingsShowFullReview from '../../rfp-ratings-show-full-review/rfp-ratings-show-full-review.vue';
import RefappStarRating from '../../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-most-helpful-favorable-review',
  components: {
    RfpRatingsShowFullReview,
    RefappStarRating,
  },
  provide() {
    const counts = {};
    Object.defineProperty(counts, 'helpfulCount', {
      enumerable: true,
      get: () => this.localHelpfulCount,
    });
    Object.defineProperty(counts, 'notHelpfulCount', {
      enumerable: true,
      get: () => this.localNotHelpfulCount,
    });

    return {
      counts,
      starRatingActiveColor: this.fields.starRatingActiveColor || this.starRatingActiveColorMhfr,
      starRatingInactiveColor:
        this.fields.starRatingInactiveColor || this.starRatingInactiveColorMhfr,
      starRatingIncrementValue: this.starRatingIncrementValueMhfr,
      starRatingMaxRatingValue: this.starRatingMaxRatingValueMhfr,
      starRatingStarSize: this.fields.starSize || this.starRatingStarSizeMhfr,
      isRightToLeftActive: this.isRightToLeftActiveMhfr,
      starRatingAccessibleLabel: this.starRatingAccessibleLabel,
      voteHelpfulAccessibleLabel: this.voteHelpfulAccessibleLabel,
      voteNotHelpfulAccessibleLabel: this.voteNotHelpfulAccessibleLabel,
    };
  },
  props: {
    headerTitleMhfr: {
      type: String,
      required: true,
    },
    starRatingIncrementValueMhfr: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValueMhfr: {
      type: Number,
      required: true,
    },
    starRatingInactiveColorMhfr: {
      type: String,
      required: true,
    },
    starRatingActiveColorMhfr: {
      type: String,
      required: true,
    },
    starRatingStarSizeMhfr: {
      type: Number,
      required: true,
    },
    ratingMhfr: {
      type: Number,
      required: true,
    },
    labelDateMhfr: {
      type: String,
      required: false,
    },
    reviewDateMhfr: {
      type: String,
      required: false,
    },
    subTitleMhfr: {
      type: String,
      required: false,
    },
    subContentMhfr: {
      type: String,
      required: false,
    },
    showFullReviewMhfr: {
      type: String,
      required: true,
    },
    labelHelpfulMhfr: {
      type: String,
      required: false,
    },
    filterStarReviewsMhfr: {
      type: String,
      required: true,
    },
    noFavorableReviewFoundMhfr: {
      type: Boolean,
      required: true,
    },
    noFavorableReviewFoundTextMhfr: {
      type: String,
      required: true,
    },
    headerTitlePopupMhfr: {
      type: String,
      required: false,
    },
    labelQualityOfProductMhfr: {
      type: String,
      required: true,
    },
    rateQualityOfProductMhfr: {
      type: String,
      required: true,
    },
    summaryMhfr: {
      type: String,
      required: false,
    },
    rridMhfr: {
      type: Number,
      required: true,
    },
    helpfulLabelMhfr: {
      type: String,
      required: true,
    },
    reportMhfr: {
      type: String,
      required: true,
    },
    reportedTextMhfr: {
      type: String,
      required: true,
    },
    reportTextMhfr: {
      type: String,
      required: true,
    },
    isVotedByUser: {
      type: Boolean,
      required: true,
    },
    helpfulCountMhfr: {
      type: Number,
      required: true,
    },
    notHelpfulCountMhfr: {
      type: Number,
      required: true,
    },
    updateHelpfulReviewApiMhfr: {
      type: String,
      required: true,
    },
    updateNotHelpfulReviewApiMhfr: {
      type: String,
      required: true,
    },
    reportReviewApiMhfr: {
      type: String,
      required: true,
    },
    isRecommendMhfr: {
      type: String,
      required: false,
    },
    commentAddedButtonMhfr: {
      type: String,
      required: true,
    },
    commentAddedMhfr: {
      type: String,
      required: true,
    },
    helpfulIconMhfr: {
      type: String,
      required: true,
    },
    helpfulIconAltMhfr: {
      type: String,
      required: true,
    },
    nonHelpfulIconMhfr: {
      type: String,
      required: true,
    },
    nonHelpfulIconAltMhfr: {
      type: String,
      required: true,
    },
    recommendListIconMhfr: {
      type: String,
      required: true,
    },
    recommendIconAltTextMhfr: {
      type: String,
      required: true,
    },
    productNameMhfr: {
      type: String,
      required: true,
    },
    facebookCaptionMhfr: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabledMhfr: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfigMhfr: {
      type: String,
      required: true,
    },
    facebookIconMhfr: {
      type: String,
      default: '',
    },
    facebookIconAltMhfr: {
      type: String,
      default: '',
    },
    isRightToLeftActiveMhfr: {
      type: Boolean,
      default: false,
    },
    showHideNicknameMhfr: {
      type: Boolean,
      required: true,
    },
    showCreatedAtMhfr: {
      type: Boolean,
      default: true,
    },
    showHideSubTitleMhfr: {
      type: Boolean,
      required: true,
    },
    showHideQualityOfProductMhfr: {
      type: Boolean,
      required: true,
    },
    isProductFreeMhfr: {
      type: Boolean,
      required: false,
    },
    isProductFreeDisplayTextMhfr: {
      type: String,
      default: '',
    },
    showFreeProductMhfr: {
      type: Boolean,
      required: false,
    },
    fields: {
      type: Object,
      required: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
    starRatingAccessibleLabel: {
      type: String,
      default: undefined,
    },
    voteHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Helpful. {{voteCount}} people found this review helpful',
    },
    voteNotHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Not helpful. {{voteCount}} people found this review not helpful',
    },
  },
  data() {
    return {
      overallRating: this.ratingMhfr,
      activePopup: false,
      showCommentText: false,
      localHelpfulCount: this.helpfulCountMhfr,
      localNotHelpfulCount: this.notHelpfulCountMhfr,
      localIsVotedByUser: this.isVotedByUser,
      isReportedByUser: this.reportMhfr === this.reportedTextMhfr,
    };
  },
  created() {
    if (this.$cookies.get(`reportedCookie${this.rridMhfr}`)) {
      this.isReportedByUser = true;
    }

    if (this.$cookies.get(`helpfulCountCookie${this.rridMhfr}`)) {
      this.localIsVotedByUser = true;
    }

    eventBus.on('rfpSetReportedStatus', ({ reviewId, isReported }) => {
      if (reviewId === this.rridMhfr) {
        this.isReportedByUser = isReported;
      }
    });

    eventBus.on(
      'rfpUpdateReviewVote',
      ({
        reviewId,
        isHelpful,
        /** to rollback optimistic update */
        rollbackUpdate = false,
      }) => {
        if (reviewId !== this.rridMhfr) return;

        const updateVoteKey = isHelpful ? 'localHelpfulCount' : 'localNotHelpfulCount';
        if (rollbackUpdate) {
          this[updateVoteKey]--;
          this.localIsVotedByUser = false;
        } else {
          this[updateVoteKey]++;
          this.localIsVotedByUser = true;
        }
      },
    );
  },
  methods: {
    showFullReviewPopup() {
      this.activePopup = true;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.toggle('popup_scroll');
    },
    closeFullReviewPopup() {
      this.activePopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.remove('popup_scroll');
    },
    showComments() {
      if (this.showCommentText === true) {
        this.showCommentText = false;
      } else {
        this.showCommentText = true;
      }
    },
    filterRatingSpecific() {
      eventBus.emit('FilterstarLabel');
      setTimeout(() => {
        this.$scrollTo('#rare-list-page');
        document
          .querySelector('#rfp-rr-ratings-reviews-results-list')
          ?.focus({ preventScroll: true });
      });
    },
  },
};
</script>
